import React from 'react'

import "../../assets/styles/nav/nav-footer-btm.scss"

export default function FooterBtmNav() {
  return (
    <ul className="nav-footer-btm">
      <li><a href="https://www.shatterproof.org/contact">Contact Us</a></li>
      <li><a href="https://www.shatterproof.org/careers">Carrers</a></li>
      <li><a href="https://www.shatterproof.org/about-us/media-room">Media Room</a></li>
      <li><a href="https://www.shatterproof.org/our-partners">Partners</a></li>
      <li><a href="https://www.shatterproof.org/privacy-policy">Privacy Policy</a></li>
      <li><a href="https://www.shatterproof.org/get-involved/stay-informed">Get Our Emails</a></li>
    </ul>
  )
}
